import { render, staticRenderFns } from "./lipstick-brands.vue?vue&type=template&id=428d2e52&"
import script from "./lipstick-brands.vue?vue&type=script&lang=js&"
export * from "./lipstick-brands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports